module.exports = __webpack_public_path__ + "static/master_card-0e99bd854a08996972a8e0cbfecacce5.png";